import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { IMealCredit } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseMealCreditsDetailsPage.utils';

export const getFrequency = (
  repeating: IMealCredit['repeating']
): IMealCreditFormFields['frequency'] => (repeating ? 'repeats' : 'single');
